import "./ReportsComponent.scss";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import ENV from "../../../constants/ENV";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import useSystemLockUpdateLabOs from "../../../shared/hooks/useSystemLockUpdateLabOs";

interface ReportsComponentProps {

}

const ReportsComponent = (props: ReportsComponentProps) => {
    useSystemLockUpdateLabOs();
    const dispatch = useDispatch();
    const token = useSelector((state: any) => state.account.token);
    let LabUrl = `${ENV.LAB_OS_URL}?module=reports_list&token=${token}`

    useEffect(() => {
        dispatch(setCurrentNavParams("Lab OS", "LabOS"));
        dispatch(setSideMenuView('compact'));
    }, [dispatch]);

    const {currentUser} = useSelector((state: any) => state.account);
    const {selectedLab} = useSelector((state: any) => state.selectedLab);
    if(currentUser?.roleObj?.code !== "labAdmin" && selectedLab){
        LabUrl = `${ENV.LAB_OS_URL}?module=reports_list&token=${token}&labId=${selectedLab}`
    }
    return (
        <div className={'reports-component lab-os-component'}>
            <iframe
                src={LabUrl}
                // src={`http://192.168.0.7:3005?token=${token}`}
                className={'labOs-iframe'}
                width="100%"
                height="100%"
                title={'LabOs'}
                loading={'eager'}
            />
        </div>
    );

};

export default ReportsComponent;
